import React, { Component } from "react";
import {
  Form,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  FormGroup,
  ToggleButtonGroup,
  ToggleButton,
  Spinner,
} from "react-bootstrap";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { DatePicker } from "@material-ui/pickers";
import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";

import {
  GetClusters,
  GetAreas,
  GetBranchByCode,
} from "../../../../store/actions/crdm_service_actions";
import { connect } from "react-redux";
import moment from "moment";
import { Formik } from "formik";
import { closeModal } from "../../../../store/actions/ModalActions";
import { toastr } from "react-redux-toastr";

const modulelistforCoveredDate = [
  {
    label: "Branch Category",
    value: moduleNames.branchCategory,
  },
  {
    label: "Customer Profiling",
    value: moduleNames.customerProfiling,
  },
  {
    label: "Packages",
    value: moduleNames.packages,
  },
  {
    label: "Active Pawns",
    value: moduleNames.salesActive,
  },
  {
    label: "Expired Pawns",
    value: moduleNames.salesExpired,
  },
  {
    label: "Unredeemed Pawns",
    value: moduleNames.unredeemedPawns,
  },
];

const modulelistforSpecificPeriod = [
  {
    label: "Branch Category",
    value: moduleNames.branchCategory,
  },
  {
    label: "Customer Profiling",
    value: moduleNames.customerProfiling,
  },
  {
    label: "Packages",
    value: moduleNames.packages,
  },
];

class GeneralFilter extends Component {
  state = {
    scopeDateDialogVisible: false,
    scopeEndDateDialogVisible: false,
    selectedAllDiagrams: true,
    isGeneralFilterInDateRange: false,
    RunningBalance: false,
    operationScope: "Overall",
    scopeDate: moment(Date.now()).format("MMMM DD YYYY"),
    scopeDateEnd: moment(Date.now()).format("MMMM DD YYYY"),
    diagramsToFilter: modulelistforCoveredDate,
    clusterList: [],
    areaList: [],
    branchList: [],
    selectedCluster: null,
    isRunningBalance: true,
    selectedArea: null,
    isFetching: false,
  };

  _getClusters = () => {
    this.setState({ isFetching: true });

    return this.props.GetClusters().then((resp) => {
      if (resp.problem === null) {
        var clusters = resp.data;
        this.setState({
          clusterList: clusters.map((cl) => {
            return { label: cl.name, value: cl.id };
          }),
        });
        this.setState({ isFetching: false });
      }
    });
  };

  _getAreas = () => {
    this.setState({ isFetching: true });
    return this.props.GetAreas().then((resp) => {
      if (resp.problem === null) {
        var areas = resp.data;
        this.setState({
          areaList: areas.map((ar) => {
            return {
              label: `${ar.areaName} (${ar.areaCode})`,
              value: ar.areaCode,
            };
          }),
        });
        this.setState({ isFetching: false });
      }
    });
  };

  prepareDiagramsToFilter(diagramsToFilter) {
    return {
      branchCategory: diagramsToFilter.some(
        (diagram) => diagram.value === moduleNames.branchCategory
      ),
      packages: diagramsToFilter.some(
        (diagram) => diagram.value === moduleNames.packages
      ),
      customerProfiling: diagramsToFilter.some(
        (diagram) => diagram.value === moduleNames.customerProfiling
      ),
      salesActive: diagramsToFilter.some(
        (diagram) => diagram.value === moduleNames.salesActive
      ),
      salesExpired: diagramsToFilter.some(
        (diagram) => diagram.value === moduleNames.salesExpired
      ),
      unredeemedPawns: diagramsToFilter.some(
        (diagram) => diagram.value === moduleNames.unredeemedPawns
      ),
      ranking: diagramsToFilter.some(
        (diagram) => diagram.value === moduleNames.ranking
      ),
    };
  }

  getLastMonth = (scopeDate) => {
    var currentMonth = new Date(scopeDate);
    var lastMonth = new Date(moment(scopeDate).subtract(1, "months"));

    lastMonth.setYear(
      currentMonth.getMonth() === 0
        ? currentMonth.getFullYear() - 1
        : currentMonth.getFullYear()
    );
    return new Date(lastMonth);
  };

  getLastYear = (scopeDate) => {
    var currentYear = new Date(scopeDate);
    var lastYear = new Date(scopeDate);
    lastYear.setMonth(currentYear.getMonth());
    lastYear.setYear(currentYear.getFullYear() - 1);
    return new Date(lastYear);
  };

  handlebranchCode = (fieldData) => {
    this.setState({ branchList: fieldData });
  };

  PremiseGetBranchByCode = (code) => {
    return this.props.GetBranchByCode(code);
  };

  loadOptions = (inputValue, callback) => {
    // do some work

    if (inputValue.length >= 3) {
      this.PremiseGetBranchByCode(inputValue).then((resp) => {
        if (resp.problem === null) {
          if (resp.data && resp.data.length > 0) {
            const currentItem = resp.data[0];
            return callback([
              {
                label: `(${currentItem.branchCode}) ${currentItem.branchName}`,
                value: currentItem.branchCode,
              },
            ]);
          }

          return callback([]);
        }

        return callback([]);
      });
    } else {
      return callback([]);
    }
  };

  renderScopeDetails = (values, errors, setFieldValue) => {
    switch (values.operationScope) {
      case "Overall":
        return <div></div>;

      case "SpecificCluster":
      case "SpecificArea":
      case null:
        return this.renderClusterAndAreaSelect(values, errors, setFieldValue);

      case "SpecificBranch":
        return this.renderBranchSelect();

      default:
        return <div>Test</div>;
    }
  };

  renderBranchSelect = () => {
    return (
      <AsyncSelect
        isMulti={true}
        placeholder="Enter Branch Codes"
        cacheOptions
        defaultOptions
        onChange={this.handlebranchCode}
        loadOptions={this.loadOptions}
      />
    );
  };

  renderScopeName = (operationScope) => {
    switch (operationScope) {
      case "SpecificCluster":
        return "Cluster";

      case "SpecificArea":
        return "Area";

      case "SpecificBranch":
        return "Branch";

      default:
        return "";
    }
  };

  renderClusterAndAreaSelect = (values, errors, setFieldValue) => {
    return (
      <FormGroup as={Col}>
        <Form.Label className="h6">
          {this.renderScopeName(values.operationScope)}
        </Form.Label>

        <Select
          id={
            values.operationScope === "SpecificCluster"
              ? "selectedCluster"
              : "selectedArea"
          }
          isDisabled={this.state.isFetching}
          isLoading={this.state.isFetching}
          loadingMessage="Fetching data.. please wait"
          onChange={(e) => {
            setFieldValue("selectedCluster", null);
            setFieldValue("selectedArea", null);
            setFieldValue(
              values.operationScope === "SpecificCluster"
                ? "selectedCluster"
                : "selectedArea",
              e
            );
          }}
          value={
            values.operationScope === "SpecificCluster"
              ? values.selectedCluster
              : values.selectedArea
          }
          isSearchable={true}
          placeholder="Select Operation Scope"
          options={
            values.operationScope === "SpecificCluster"
              ? this.state.clusterList
              : this.state.areaList
          }
        />
        <Form.Control.Feedback type="invalid">
          {errors.operationScope}
        </Form.Control.Feedback>
      </FormGroup>
    );
  };

  render() {
    return (
      <Formik
        initialValues={{
          selectedAllDiagrams: this.state.selectedAllDiagrams,
          isGeneralFilterInDateRange: this.state.isGeneralFilterInDateRange,
          diagramsToFilter: this.state.diagramsToFilter,
          operationScope: this.state.operationScope,
          scopeDate: this.state.scopeDate,
          scopeDateEnd: this.state.scopeDateEnd,
          selectedCluster: this.state.selectedCluster,
          selectedArea: this.state.selectedArea,
        }}
        onSubmit={(values, actions) => {
          var lastMonth = this.getLastMonth(values.scopeDate);
          var lastYear = this.getLastYear(values.scopeDate);

          var current_date = new Date(values.scopeDate);
          var end_date = new Date(values.scopeDateEnd);

          var preparedDiagramsToFilter = this.prepareDiagramsToFilter(
            values.diagramsToFilter
          );
          var payload = {
            lastMonth: lastMonth,
            lastYear: lastYear,
            scopeDate: current_date,
            scopeDateEnd: end_date,
            diagramsToFilter: preparedDiagramsToFilter,
            operationScope: values.operationScope,
            selectedArea: values.selectedArea,
            selectedCluster: values.selectedCluster,
            selectedBranches: this.state.branchList,
            isRunningBalance: this.state.isRunningBalance,
            isGeneralFilterInDateRange: this.state.isGeneralFilterInDateRange,
          };

          var faulted = [];

          if (values.operationScope === OperationScope.overall) {
            faulted.push({
              name: "Overall",
              result: true,
            });
          }

          if (values.operationScope === OperationScope.specifiedCluster) {
            faulted.push({
              name: "Cluster",
              result: values.selectedCluster !== null,
            });
          }

          if (values.operationScope === OperationScope.specifiedArea) {
            faulted.push({
              name: "Area",
              result: values.selectedArea !== null,
            });
          }

          if (values.operationScope === OperationScope.specifiedBranch) {
            faulted.push({
              name: "Branch",
              result: this.state.branchList.length > 0,
            });
          }

          var assesment = faulted[0];

          if (assesment.result === true) {
            this.props
              .filterOverall(payload)
              .then(() => {
                actions.setSubmitting(false);
                this.props.closeModal();
              })
              .catch(() => {
                actions.setSubmitting(false);
                this.props.closeModal();
              });
          } else {
            toastr.confirm(`Please specify an ${assesment.name} to proceed.`, {
              disableCancel: true,
            });
            actions.setSubmitting(false);
          }
        }}
      >
        {({
          values,
          errors,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setSubmitting,
          setFieldValue,
        }) => {
          return (
            <Container>
              <Form onSubmit={handleSubmit}>
                <Form.Row>
                  <Form.Group as={Col}>
                    <Form.Label className="h6">Diagrams to filter </Form.Label>
                    <Form.Check
                      id="selectedAllDiagrams"
                      checked={values.selectedAllDiagrams}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setFieldValue("selectedAllDiagrams", isChecked); // Update toggle state

                        setFieldValue(
                          "diagramsToFilter",
                          isChecked
                            ? this.state.isGeneralFilterInDateRange
                              ? modulelistforSpecificPeriod
                              : modulelistforCoveredDate
                            : []
                        );
                      }}
                      className="float-right"
                      type="switch"
                      label="Select All"
                    />

                    <Select
                      id="diagramsToFilter"
                      isMulti={true}
                      onBlur={handleBlur}
                      onChange={(selected) =>
                        setFieldValue("diagramsToFilter", selected)
                      }
                      value={values.diagramsToFilter}
                      options={
                        this.state.isGeneralFilterInDateRange
                          ? modulelistforSpecificPeriod
                          : modulelistforCoveredDate
                      }
                      components={{ ClearIndicator: null }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.diagramsToFilter}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>

                <hr />

                <Form.Row>
                  <FormGroup as={Col}>
                    <Form.Check
                      style={{ zIndex: 0 }}
                      id="isGeneralFilterInDateRange"
                      checked={this.state.isGeneralFilterInDateRange}
                      onChange={(e) => {
                        this.setState({
                          isGeneralFilterInDateRange: e.target.checked,
                        });
                        setFieldValue(
                          "diagramsToFilter",
                          e.target.checked
                            ? modulelistforSpecificPeriod
                            : modulelistforCoveredDate
                        );
                      }}
                      className="float-right"
                      type="switch"
                      label="Specific period"
                    />
                  </FormGroup>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col}>
                    <Form.Label className="h6">
                      {this.state.isGeneralFilterInDateRange
                        ? "From"
                        : "Covered Date"}
                    </Form.Label>

                    <DatePicker
                      TextFieldComponent={() => {
                        return (
                          <Form.Control
                            onClick={() =>
                              this.setState({ scopeDateDialogVisible: true })
                            }
                            defaultValue={moment(values.scopeDate).format(
                              "MMMM DD YYYY"
                            )}
                            type="text"
                            placeholder="Enter"
                          />
                        );
                      }}
                      openTo="year"
                      showTodayButton={true}
                      disableFuture={true}
                      disableToolbar
                      open={this.state.scopeDateDialogVisible}
                      onClose={() =>
                        this.setState({
                          scopeDateDialogVisible: false,
                        })
                      }
                      value={
                        values.scopeDate
                          ? moment(values.scopeDate).format("MMMM DD YYYY")
                          : null
                      }
                      orientation="landscape"
                      fullWidth
                      onChange={(e) => {
                        var value = new Date(e);
                        setFieldValue("scopeDate", value);
                      }}
                      variant="dialog"
                      views={["year", "month", "date"]}
                      format="YYYY"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.scopeDate}
                    </Form.Control.Feedback>
                  </Form.Group>

                  {this.state.isGeneralFilterInDateRange && (
                    <Form.Group as={Col}>
                      <Form.Label className="h6">To</Form.Label>
                      <DatePicker
                        TextFieldComponent={() => {
                          return (
                            <Form.Control
                              id="scopeDateEnd"
                              onClick={() => {
                                this.setState({
                                  scopeEndDateDialogVisible: true,
                                });
                              }}
                              defaultValue={moment(values.scopeDateEnd).format(
                                "MMMM DD YYYY"
                              )}
                              type="text"
                              placeholder="Enter Scope Date"
                            />
                          );
                        }}
                        openTo="year"
                        showTodayButton={true}
                        disableFuture={true}
                        disableToolbar
                        open={this.state.scopeEndDateDialogVisible}
                        onClose={() =>
                          this.setState({
                            scopeEndDateDialogVisible: false,
                          })
                        }
                        value={
                          values.scopeDateEnd
                            ? moment(values.scopeDateEnd).format("MMMM DD YYYY")
                            : null
                        }
                        orientation="landscape"
                        fullWidth
                        onChange={(e) => {
                          var value = new Date(e);
                          setFieldValue("scopeDateEnd", value);
                        }}
                        variant="dialog"
                        views={["year", "month", "date"]}
                        format="YYYY"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.scopeDateEnd}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}
                </Form.Row>

                <hr />

                <Form.Row style={{ zIndex: 0 }}>
                  <Form.Group as={Col}>
                    <Form.Label className="h6 mr-2">
                      Operations Scope
                    </Form.Label>
                    <Row>
                      <Col>
                        <ToggleButtonGroup
                          style={{ zIndex: 0 }}
                          type="radio"
                          size="sm"
                          value={values.operationScope}
                          name="operationScope"
                          id="operationScope"
                        >
                          <ToggleButton
                            size="sm"
                            variant="light"
                            onClick={() => {
                              setFieldValue("operationScope", "Overall");
                              setSubmitting(false);
                            }}
                            value="Overall"
                          >
                            Overall
                          </ToggleButton>

                          <ToggleButton
                            size="sm"
                            variant="light"
                            onClick={() => {
                              setFieldValue(
                                "operationScope",
                                "SpecificCluster"
                              );
                              this._getClusters();
                              setSubmitting(false);
                            }}
                            value="SpecificCluster"
                          >
                            Specific Cluster
                          </ToggleButton>
                          <ToggleButton
                            size="sm"
                            variant="light"
                            onClick={() => {
                              setFieldValue("operationScope", "SpecificArea");
                              this._getAreas();
                              setSubmitting(false);
                            }}
                            value="SpecificArea"
                          >
                            Specific Area
                          </ToggleButton>
                          <ToggleButton
                            size="sm"
                            variant="light"
                            onClick={() => {
                              setFieldValue("operationScope", "SpecificBranch");
                              setSubmitting(false);
                            }}
                            value="SpecificBranch"
                          >
                            Specific Branch
                          </ToggleButton>
                        </ToggleButtonGroup>
                        <Form.Control.Feedback type="invalid">
                          {errors.operationScope}
                        </Form.Control.Feedback>
                      </Col>
                    </Row>
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <FormGroup as={Col}>
                    {this.renderScopeDetails(values, errors, setFieldValue)}
                  </FormGroup>
                </Form.Row>

                <Form.Row>
                  <FormGroup as={Col}>
                    <ButtonToolbar className="float-right">
                      <Button disabled={isSubmitting} type="submit">
                        <Spinner
                          animation="border"
                          size="sm"
                          className="mr-1"
                          hidden={!isSubmitting}
                        />
                        {isSubmitting
                          ? "Fetching, please wait..."
                          : "View Summary"}
                      </Button>
                    </ButtonToolbar>
                  </FormGroup>
                </Form.Row>
              </Form>
            </Container>
          );
        }}
      </Formik>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  closeModal: closeModal,
  GetClusters,
  GetAreas,
  GetBranchByCode: GetBranchByCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralFilter);
